/* eslint-disable import/prefer-default-export */
import axios from '../../../core/services/axios';

export const sendEmailInvite = (data) => axios.post('/api/users', {
  ...data,
  type: 'send_email_invite',
});

export const inviteAssignee = (data) => axios.post('/api/users/invite-initiative-assignee', data);
